// All reports
import {durationToHoursStr} from 'shared';

const duration = (value) => {
  return durationToHoursStr(value) + ' h';
};

const hectareUnit = (value) => {
  return value.toFixed(2) + ' ha';
};

const FieldsInterventionsReports = [
  {label: 'Géneral', value: 'general', group: 'Génerale'},
  {label: 'Reporting Des Travaux Agricoles', value: 'general-ii', group: 'Génerale'},
  {label: 'Surface Travaillée Mensuelle par Tracteur', value: 'monthly-tractor-work-area', group: 'Opérations Agricoles'},
  {label: 'Utilisation des tracteurs', value: 'tractors-usage', group: 'Opérations Agricoles'},
  {label: 'Le choix de la puissance du tracteur et la largeur de l\'outil', value: 'tractors-trailer-width-choice', group: 'Opérations Agricoles'},
  {label: 'La repartition des durées de l\'utilisation des tracteurs en %', value: 'time-repartition', group: 'Opérations Agricoles'},
  {label: 'Débit chantier moyen Ha/h', value: 'throughput-per-operation-trailer', group: 'Opérations Agricoles'},
  {label: 'La vitesse d\'execution des operations agricoles', value: 'speed-per-operation-trailer', group: 'Opérations Agricoles'},
  {label: 'Le suivi de l\'avancement des travaux', value: 'operations-progress', group: 'Opérations Agricoles'},
  {label: 'Consomation carburant par Opérations', value: 'fuel-consumption-per-operation', group: 'Opérations Agricoles'},
];

export default FieldsInterventionsReports;
